export class Passport {
  public static passport_countries = [
    { label: "Afganistán", value: "AFG" },
    { label: "Åland", value: "ALA" },
    { label: "Albania", value: "ALB" },
    { label: "Alemania", value: "DEU" },
    { label: "Andorra", value: "AND" },
    { label: "Angola", value: "AGO" },
    { label: "Anguila", value: "AIA" },
    { label: "Antártida", value: "ATA" },
    { label: "Antigua y Barbuda", value: "ATG" },
    { label: "Arabia Saudita", value: "SAU" },
    { label: "Argelia", value: "DZA" },
    { label: "Argentina", value: "ARG" },
    { label: "Armenia", value: "ARM" },
    { label: "Aruba", value: "ABW" },
    { label: "Australia", value: "AUS" },
    { label: "Austria", value: "AUT" },
    { label: "Azerbaiyán", value: "AZE" },
    { label: "Bahamas", value: "BHS" },
    { label: "Bangladés", value: "BGD" },
    { label: "Barbados", value: "BRB" },
    { label: "Baréin", value: "BHR" },
    { label: "Bélgica", value: "BEL" },
    { label: "Belice", value: "BLZ" },
    { label: "Benín", value: "BEN" },
    { label: "Bermudas", value: "BMU" },
    { label: "Bielorrusia", value: "BLR" },
    { label: "Bolivia", value: "BOL" },
    { label: "Bonaire, San Eustaquio y Saba", value: "BES" },
    { label: "Bosnia y Herzegovina", value: "BIH" },
    { label: "Botsuana", value: "BWA" },
    { label: "Brasil", value: "BRA" },
    { label: "Brunéi", value: "BRN" },
    { label: "Bulgaria", value: "BGR" },
    { label: "Burkina Faso", value: "BFA" },
    { label: "Burundi", value: "BDI" },
    { label: "Bután", value: "BTN" },
    { label: "Cabo Verde", value: "CPV" },
    { label: "Camboya", value: "KHM" },
    { label: "Camerún", value: "CMR" },
    { label: "Canadá", value: "CAN" },
    { label: "Catar", value: "QAT" },
    { label: "Chad", value: "TCD" },
    { label: "Chile", value: "CHL" },
    { label: "China", value: "CHN" },
    { label: "Chipre", value: "CYP" },
    { label: "Colombia", value: "COL" },
    { label: "Comoras", value: "COM" },
    { label: "Corea del Norte", value: "PRK" },
    { label: "Corea del Sur", value: "KOR" },
    { label: "Costa de Marfil", value: "CIV" },
    { label: "Costa Rica", value: "CRI" },
    { label: "Croacia", value: "HRV" },
    { label: "Cuba", value: "CUB" },
    { label: "Curazao", value: "CUW" },
    { label: "Dinamarca", value: "DNK" },
    { label: "Dominica", value: "DMA" },
    { label: "Ecuador", value: "ECU" },
    { label: "Egipto", value: "EGY" },
    { label: "El Salvador", value: "SLV" },
    { label: "Emiratos Árabes Unidos", value: "ARE" },
    { label: "Eritrea", value: "ERI" },
    { label: "Eslovaquia", value: "SVK" },
    { label: "Eslovenia", value: "SVN" },
    { label: "España", value: "ESP" },
    { label: "Estados Unidos", value: "USA" },
    { label: "Estonia", value: "EST" },
    { label: "Etiopía", value: "ETH" },
    { label: "Filipinas", value: "PHL" },
    { label: "Finlandia", value: "FIN" },
    { label: "Fiyi", value: "FJI" },
    { label: "Francia", value: "FRA" },
    { label: "Gabón", value: "GAB" },
    { label: "Gambia", value: "GMB" },
    { label: "Georgia", value: "GEO" },
    { label: "Ghana", value: "GHA" },
    { label: "Gibraltar", value: "GIB" },
    { label: "Granada", value: "GRD" },
    { label: "Grecia", value: "GRC" },
    { label: "Groenlandia", value: "GRL" },
    { label: "Guadalupe", value: "GLP" },
    { label: "Guam", value: "GUM" },
    { label: "Guatemala", value: "GTM" },
    { label: "Guayana Francesa", value: "GUF" },
    { label: "Guernsey", value: "GGY" },
    { label: "Guinea", value: "GIN" },
    { label: "Guinea-Bisáu", value: "GNB" },
    { label: "Guinea Ecuatorial", value: "GNQ" },
    { label: "Guyana", value: "GUY" },
    { label: "Haití", value: "HTI" },
    { label: "Honduras", value: "HND" },
    { label: "Hong Kong", value: "HKG" },
    { label: "Hungría", value: "HUN" },
    { label: "India", value: "IND" },
    { label: "Indonesia", value: "IDN" },
    { label: "Irak", value: "IRQ" },
    { label: "Irán", value: "IRN" },
    { label: "Irlanda", value: "IRL" },
    { label: "Isla Bouvet", value: "BVT" },
    { label: "Isla de Man", value: "IMN" },
    { label: "Isla de Navidad", value: "CXR" },
    { label: "Islandia", value: "ISL" },
    { label: "Islas Caimán", value: "CYM" },
    { label: "Islas Cocos", value: "CCK" },
    { label: "Islas Cook", value: "COK" },
    { label: "Islas Feroe", value: "FRO" },
    { label: "Islas Georgias del Sur y Sandwich del Sur", value: "SGS" },
    { label: "Islas Heard y McDonald", value: "HMD" },
    { label: "Islas Malvinas", value: "FLK" },
    { label: "Islas Marianas del Norte", value: "MNP" },
    { label: "Islas Marshall", value: "MHL" },
    { label: "Islas Pitcairn", value: "PCN" },
    { label: "Islas Salomón", value: "SLB" },
    { label: "Islas Turcas y Caicos", value: "TCA" },
    { label: "Islas Ultramarinas Menores de los Estados Unidos", value: "UMI" },
    { label: "Islas Vírgenes Británicas", value: "VGB" },
    { label: "Islas Vírgenes de los Estados Unidos", value: "VIR" },
    { label: "Israel", value: "ISR" },
    { label: "Italia", value: "ITA" },
    { label: "Jamaica", value: "JAM" },
    { label: "Japón", value: "JPN" },
    { label: "Jersey", value: "JEY" },
    { label: "Jordania", value: "JOR" },
    { label: "Kazajistán", value: "KAZ" },
    { label: "Kenia", value: "KEN" },
    { label: "Kirguistán", value: "KGZ" },
    { label: "Kiribati", value: "KIR" },
    { label: "Kuwait", value: "KWT" },
    { label: "Laos", value: "LAO" },
    { label: "Lesoto", value: "LSO" },
    { label: "Letonia", value: "LVA" },
    { label: "Líbano", value: "LBN" },
    { label: "Liberia", value: "LBR" },
    { label: "Libia", value: "LBY" },
    { label: "Liechtenstein", value: "LIE" },
    { label: "Lituania", value: "LTU" },
    { label: "Luxemburgo", value: "LUX" },
    { label: "Macao", value: "MAC" },
    { label: "Macedonia del Norte", value: "MKD" },
    { label: "Madagascar", value: "MDG" },
    { label: "Malasia", value: "MYS" },
    { label: "Malaui", value: "MWI" },
    { label: "Maldivas", value: "MDV" },
    { label: "Malí", value: "MLI" },
    { label: "Malta", value: "MLT" },
    { label: "Marruecos", value: "MAR" },
    { label: "Martinica", value: "MTQ" },
    { label: "Mauricio", value: "MUS" },
    { label: "Mauritania", value: "MRT" },
    { label: "Mayotte", value: "MYT" },
    { label: "México", value: "MEX" },
    { label: "Micronesia", value: "FSM" },
    { label: "Moldavia", value: "MDA" },
    { label: "Mónaco", value: "MCO" },
    { label: "Mongolia", value: "MNG" },
    { label: "Montenegro", value: "MNE" },
    { label: "Montserrat", value: "MSR" },
    { label: "Mozambique", value: "MOZ" },
    { label: "Birmania", value: "MMR" },
    { label: "Namibia", value: "NAM" },
    { label: "Nauru", value: "NRU" },
    { label: "Nepal", value: "NPL" },
    { label: "Nicaragua", value: "NIC" },
    { label: "Níger", value: "NER" },
    { label: "Nigeria", value: "NGA" },
    { label: "Niue", value: "NIU" },
    { label: "Isla Norfolk", value: "NFK" },
    { label: "Noruega", value: "NOR" },
    { label: "Nueva Caledonia", value: "NCL" },
    { label: "Nueva Zelanda", value: "NZL" },
    { label: "Omán", value: "OMN" },
    { label: "Países Bajos", value: "NLD" },
    { label: "Pakistán", value: "PAK" },
    { label: "Palaos", value: "PLW" },
    { label: "Palestina", value: "PSE" },
    { label: "Panamá", value: "PAN" },
    { label: "Papúa Nueva Guinea", value: "PNG" },
    { label: "Paraguay", value: "PRY" },
    { label: "Perú", value: "PER" },
    { label: "Polinesia Francesa", value: "PYF" },
    { label: "Polonia", value: "POL" },
    { label: "Portugal", value: "PRT" },
    { label: "Puerto Rico", value: "PRI" },
    { label: "Reino Unido", value: "GBR" },
    { label: "República Árabe Saharaui Democrática", value: "ESH" },
    { label: "República Centroafricana", value: "CAF" },
    { label: "República Checa", value: "CZE" },
    { label: "República del Congo", value: "COG" },
    { label: "República Democrática del Congo", value: "COD" },
    { label: "República Dominicana", value: "DOM" },
    { label: "Reunión", value: "REU" },
    { label: "Ruanda", value: "RWA" },
    { label: "Rumania", value: "ROU" },
    { label: "Rusia", value: "RUS" },
    { label: "Samoa", value: "WSM" },
    { label: "Samoa Americana", value: "ASM" },
    { label: "San Bartolomé", value: "BLM" },
    { label: "San Cristóbal y Nieves", value: "KNA" },
    { label: "San Marino", value: "SMR" },
    { label: "San Martín", value: "MAF" },
    { label: "San Pedro y Miquelón", value: "SPM" },
    { label: "San Vicente y las Granadinas", value: "VCT" },
    { label: "Santa Elena, Ascensión y Tristán de Acuña", value: "SHN" },
    { label: "Santa Lucía", value: "LCA" },
    { label: "Santo Tomé y Príncipe", value: "STP" },
    { label: "Senegal", value: "SEN" },
    { label: "Serbia", value: "SRB" },
    { label: "Seychelles", value: "SYC" },
    { label: "Sierra Leona", value: "SLE" },
    { label: "Singapur", value: "SGP" },
    { label: "San Martín", value: "SXM" },
    { label: "Siria", value: "SYR" },
    { label: "Somalia", value: "SOM" },
    { label: "Sri Lanka", value: "LKA" },
    { label: "Suazilandia", value: "SWZ" },
    { label: "Sudáfrica", value: "ZAF" },
    { label: "Sudán", value: "SDN" },
    { label: "Sudán del Sur", value: "SSD" },
    { label: "Suecia", value: "SWE" },
    { label: "Suiza", value: "CHE" },
    { label: "Surinam", value: "SUR" },
    { label: "Svalbard y Jan Mayen", value: "SJM" },
    { label: "Tailandia", value: "THA" },
    { label: "Taiwán (República de China)", value: "TWN" },
    { label: "Tanzania", value: "TZA" },
    { label: "Tayikistán", value: "TJK" },
    { label: "Territorio Británico del Océano Índico", value: "IOT" },
    { label: "Tierras Australes y Antárticas Francesas", value: "ATF" },
    { label: "Timor Oriental", value: "TLS" },
    { label: "Togo", value: "TGO" },
    { label: "Tokelau", value: "TKL" },
    { label: "Tonga", value: "TON" },
    { label: "Trinidad y Tobago", value: "TTO" },
    { label: "Túnez", value: "TUN" },
    { label: "Turkmenistán", value: "TKM" },
    { label: "Turquía", value: "TUR" },
    { label: "Tuvalu", value: "TUV" },
    { label: "Ucrania", value: "UKR" },
    { label: "Uganda", value: "UGA" },
    { label: "Uruguay", value: "URY" },
    { label: "Uzbekistán", value: "UZB" },
    { label: "Vanuatu", value: "VUT" },
    { label: "Ciudad del Vaticano", value: "VAT" },
    { label: "Venezuela", value: "VEN" },
    { label: "Vietnam", value: "VNM" },
    { label: "Wallis y Futuna", value: "WLF" },
    { label: "Yemen", value: "YEM" },
    { label: "Yibuti", value: "DJI" },
    { label: "Zambia", value: "ZMB" },
    { label: "Zimbabue", value: "ZWE" },
  ];

  private static character = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35,
    default: 0,
  };

  public static parseString(str: string) {
    let parsed = "";
    if (str) {
      parsed = str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
    }
    return parsed;
  }

  public static parseDate(date: Date) {
    let parsed = "";
    if (date) {
      let year = date.getFullYear().toString().substr(-2);
      let month = (date.getMonth() + 1).toString();
      if (month.length == 1) month = "0" + month;
      let day = date.getDate().toString();
      if (day.length == 1) day = "0" + day;
      parsed = year + month + day;
    }
    return parsed;
  }

  public static firstMrzLine({
    first_name,
    middle_name,
    first_last_name,
    second_last_name,
    expedition_country,
  }): string {
    first_name = this.parseString(first_name);
    middle_name = this.parseString(middle_name);
    first_last_name = this.parseString(first_last_name);
    second_last_name = this.parseString(second_last_name);

    let mrz_first_line = "P<";
    mrz_first_line += expedition_country;
    mrz_first_line += first_last_name.replace(" ", "<");
    if (second_last_name != "") {
      mrz_first_line += "<" + second_last_name.replace(" ", "<");
    }
    mrz_first_line += "<<" + first_name.replace(" ", "<");
    if (middle_name != "") {
      mrz_first_line += "<" + middle_name.replace(" ", "<");
    }
    if (mrz_first_line.length < 44) {
      mrz_first_line = this.fillMrzLine(mrz_first_line, 44);
    } else if (mrz_first_line.length > 44) {
      mrz_first_line = this.removeMrzCharacters(mrz_first_line, 44);
    }
    return mrz_first_line;
  }

  public static fillMrzLine(str: string, length: number): string {
    while (str.length < length) {
      str = str + "<";
    }
    return str;
  }

  public static removeMrzCharacters(str: string, length: number): string {
    while (str.length > length) {
      str = str.slice(0, -1);
    }
    return str;
  }

  public static secondMrzLine({ passport_number, nationality, genre, birthdate, expiry_date }): string {
    birthdate = this.parseDate(birthdate?.toDate());
    expiry_date = this.parseDate(expiry_date?.toDate());

    passport_number = this.fillMrzLine(this.parseString(passport_number), 9);
    let first_check_digit = this.calculateCheckDigit(passport_number);
    let second_check_digit = this.calculateCheckDigit(birthdate);
    let third_check_digit = this.calculateCheckDigit(expiry_date);
    let str_final_digit =
      passport_number + first_check_digit + birthdate + second_check_digit + expiry_date + third_check_digit;
    let last_check_digit = this.calculateCheckDigit(str_final_digit);
    let mrz_second_line = `${passport_number}${first_check_digit}`;
    mrz_second_line += `${nationality}${birthdate}`;
    mrz_second_line += `${second_check_digit}${genre}`;
    mrz_second_line += `${expiry_date}${third_check_digit}`;
    mrz_second_line = this.fillMrzLine(mrz_second_line, 42);
    mrz_second_line += `0${last_check_digit}`;
    return mrz_second_line;
  }

  public static calculateCheckDigit(str: string): string {
    let multiplier = 7;
    let sum = 0;
    for (let x = 0; x < str.length; x++) {
      let c = str.charAt(x);
      let value = this.character[c] || 0;
      sum += value * multiplier;
      multiplier = this.nextMultiplier(multiplier);
    }
    return (sum % 10).toString();
  }

  private static nextMultiplier(last_multiplier: number) {
    let next_multiplier: number;
    switch (last_multiplier) {
      case 7:
        next_multiplier = 3;
        break;
      case 3:
        next_multiplier = 1;
        break;
      case 1:
        next_multiplier = 7;
        break;
    }
    return next_multiplier;
  }
}
